import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { BuscaConfiguracaoImpostoAdicionalModel } from "../models/configuracaoImpostoAdicional/buscaConfiguracaoImpostoAdicionalModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarConfiguracaoImpostoAdicional, setModalDeletarConfiguracaoImpostoAdicional } from "../redux/slices/configuracaoImpostoAdicional/configuracaoImpostoAdicionalSlice";

export const cadastrarConfiguracaoImpostoAdicional = createAsyncThunk("/ConfiguracaoImpostoAdicional/CadastrarConfiguracaoImpostoAdicional", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ConfiguracaoImpostoAdicional/CadastrarConfiguracaoImpostoAdicional/", payload.value);
    toastSucess("Configuração cadastrado com sucesso");
    dispatch(setModalCadastrarConfiguracaoImpostoAdicional(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImpostoAdicional(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarConfiguracaoImpostoAdicional = createAsyncThunk("/ConfiguracaoImpostoAdicional/BuscarConfiguracaoImpostoAdicional", async (args: BuscaConfiguracaoImpostoAdicionalModel) => {
  try {
    const data = await api.get("/ConfiguracaoImpostoAdicional/BuscarConfiguracaoImpostoAdicional", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarConfiguracaoImpostoAdicional = createAsyncThunk("/ConfiguracaoImpostoAdicional/AtualizarConfiguracaoImpostoAdicional", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ConfiguracaoImpostoAdicional/AtualizarConfiguracaoImpostoAdicional/", payload.value);
    toastSucess("Configuração atualizada com sucesso");
    dispatch(setModalCadastrarConfiguracaoImpostoAdicional(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImpostoAdicional(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarConfiguracaoImpostoAdicional = createAsyncThunk("/ConfiguracaoImpostoAdicional/DeletarConfiguracaoImpostoAdicional", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ConfiguracaoImpostoAdicional/DeletarConfiguracaoImpostoAdicional/?id=" + payload.value);
    toastSucess("Configuração removida com sucesso");
    dispatch(setModalDeletarConfiguracaoImpostoAdicional(false));
    dispatch(setLoading(false));

    dispatch(listarConfiguracaoImpostoAdicional(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
